import { inject, InjectionToken } from '@angular/core';
import { CLIENT_ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment/client';
import { WebAuth } from 'auth0-js';
import { getAuthDomain } from './get-auth-domain';
import { getAuthRedirectUri } from './get-auth-redirect-uri';

export const WEBAUTH_SERVICE_TOKEN = new InjectionToken<WebAuth>(
  'Provide WebAuth to Feature Login',
  {
    factory: () => {
      const { clientId: clientID, ...auth } = inject(CLIENT_ENVIRONMENT_PROVIDER).auth;
      return new WebAuth({
        ...auth,
        clientID,
        domain: getAuthDomain(auth),
        redirectUri: getAuthRedirectUri(auth),
      });
    },
  }
);
